/* VKCardEqualizerV2: remove stale inline heights; CSS grid owns alignment. */
(function () {
  if (window.VKCardEqualizerV2) return;
  window.VKCardEqualizerV2 = true;

  var timer;

  function alignRail(rail) {
    var cards = Array.from(rail.querySelectorAll(':scope > .vk-commerce-card'));
    cards.forEach(function (card) {
      card.style.removeProperty('height');
      card.style.removeProperty('min-height');
    });
  }

  function alignAll() {
    document.querySelectorAll('.vk-commerce-rail__scroller').forEach(alignRail);
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(alignAll, 80);
  }

  document.addEventListener('DOMContentLoaded', function () {
    alignAll();
    window.setTimeout(alignAll, 350);
  });
  window.addEventListener('load', alignAll);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('vk:cart-updated', schedule);
})();
